import { Injectable } from '@angular/core';
import { Occ } from '@spartacus/core';
import { Observable } from 'rxjs';
import { InstallmentPayments } from '../../model/gg-payment.model';
import { PaymentAdapter } from './payment.adapter';

export interface RedirectURL {
  redirectURL: string;
}
@Injectable()
export class PaymentConnector {
  constructor(protected adapter: PaymentAdapter) {}

  addSelected(userId: string, cartId: string, selectedPayment: string): Observable<Occ.PaymentDetails> {
    return this.adapter.addSelected(userId, cartId, selectedPayment);
  }

  getSelected(userId: string, cartId: string): Observable<string> {
    return this.adapter.getSelected(userId, cartId);
  }

  nestpayAuthorization(userId: string, cartId: string): Observable<string> {
    return this.adapter.nestpayAuthorization(userId, cartId);
  }

  klarna(userId: string, cartId: string): Observable<string> {
    return this.adapter.klarna(userId, cartId);
  }

  megapos(userId: string, cartId: string): Observable<string> {
    return this.adapter.megapos(userId, cartId);
  }

  stripe(userId: string, cartId: string): Observable<string> {
    return this.adapter.stripe(userId, cartId);
  }

  monri(userId: string, cartId: string): Observable<string> {
    return this.adapter.monri(userId, cartId);
  }

  simplepay(userId: string, cartId: string): Observable<string> {
    return this.adapter.simplepay(userId, cartId);
  }

  gpwebpay(userId: string, cartId: string): Observable<RedirectURL> {
    return this.adapter.gpwebpay(userId, cartId);
  }

  leanpay(userId: string, cartId: string): Observable<string> {
    return this.adapter.leanpay(userId, cartId);
  }

  payway(userId: string, cartId: string): Observable<string> {
    return this.adapter.payway(userId, cartId);
  }

  getInstallmentPayments(paymentMethod: string, price: number): Observable<InstallmentPayments> {
    return this.adapter.getInstallmentPayments(paymentMethod, price);
  }

  paypal(userId: string, cartId: string): Observable<string> {
    return this.adapter.paypal(userId, cartId);
  }
}
